import { User, Briefcase, Shield, FileText, CheckCircle } from "lucide-react";

export const STEPS = [
  {
    number: 1,
    title: "Inquilino",
    shortTitle: "Inquilino",
    subtitle: "Datos personales",
    icon: User,
  },
  {
    number: 2,
    title: "Asesor",
    shortTitle: "Asesor",
    subtitle: "Información del asesor",
    icon: Briefcase,
  },
  {
    number: 3,
    title: "Fiador",
    shortTitle: "Fiador",
    subtitle: "Configuración",
    icon: Shield,
  },
  {
    number: 4,
    title: "Convenio",
    shortTitle: "Convenio",
    subtitle: "Justicia alternativa",
    icon: FileText,
  },
  {
    number: 5,
    title: "Revisión",
    shortTitle: "Revisión",
    subtitle: "Confirmar información",
    icon: CheckCircle,
  },
];
